// FIX 13/06: formatTenantTime - formata data ISO no fuso do tenant.
// Usa Intl.DateTimeFormat nativo (sem lib) - zero deps.
//
// Uso:
//   formatTenantTime("2026-06-13T18:30:00Z", "America/Manaus", "dd/MM HH:mm")
//   → "13/06 14:30"  (porque Manaus = UTC-4 vs SP UTC-3)

const FORMAT_CONFIGS = {
  "HH:mm": { hour: "2-digit", minute: "2-digit", hour12: false },
  "dd/MM HH:mm": {
    day: "2-digit", month: "2-digit",
    hour: "2-digit", minute: "2-digit", hour12: false
  },
  "dd/MM/yyyy HH:mm": {
    day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit", hour12: false
  },
  "dd/MM/yyyy": { day: "2-digit", month: "2-digit", year: "numeric" }
};

export function formatTenantTime(dateInput, timezone, format = "HH:mm") {
  if (!dateInput) return "";
  const tz = timezone || "America/Sao_Paulo";
  const d = typeof dateInput === "string" ? new Date(dateInput) : dateInput;
  if (isNaN(d.getTime())) return "";

  const cfg = FORMAT_CONFIGS[format] || FORMAT_CONFIGS["HH:mm"];
  try {
    const parts = new Intl.DateTimeFormat("pt-BR", {
      timeZone: tz,
      ...cfg
    }).formatToParts(d);
    const get = (t) => parts.find(p => p.type === t)?.value || "";

    if (format === "HH:mm") return `${get("hour")}:${get("minute")}`;
    if (format === "dd/MM HH:mm") return `${get("day")}/${get("month")} ${get("hour")}:${get("minute")}`;
    if (format === "dd/MM/yyyy HH:mm") return `${get("day")}/${get("month")}/${get("year")} ${get("hour")}:${get("minute")}`;
    if (format === "dd/MM/yyyy") return `${get("day")}/${get("month")}/${get("year")}`;
    return parts.map(p => p.value).join("");
  } catch (_) {
    // fallback - browser local
    return d.toLocaleString("pt-BR");
  }
}

export default formatTenantTime;
